import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  tone?: "default" | "muted" | "accent" | "info";
}

export function Chip({ children, tone = "default" }: Props) {
  return <span className={`bbc-chip bbc-chip-${tone}`}>{children}</span>;
}
